export default __webpack_public_path__ + "web/react/components/follow-designer-send-to-app-modal/images/follow-image2.a4b38c478a2e22b8efaf0fe2d02bc9ed.png";